package com.trevorwiebe.timesheet.admin.loadrate.presentation

import com.trevorwiebe.timesheet.admin.loadrate.domain.model.LoadRate
import com.trevorwiebe.timesheet.admin.loadrate.domain.model.LoadRateCategory
import com.trevorwiebe.timesheet.mileage.domain.model.Location

data class LoadRateState(
    val loadRates: List<LoadRate> = emptyList(),
    val visibleLoadRates: List<LoadRate> = emptyList(),
    val locations: List<Location> = emptyList(),
    val searchQuery: String = "",
    val activeFilters: Set<LoadRateCategory> = emptySet(),
    val showAddEditDialog: Boolean = false,
    val editingLoadRate: LoadRate? = null,
    val isLoading: Boolean = false,
    val error: String? = null,
)
